import { render, staticRenderFns } from "./ProcessTaskFormFields.vue?vue&type=template&id=9f0d919a&"
import script from "./ProcessTaskFormFields.vue?vue&type=script&lang=js&"
export * from "./ProcessTaskFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports